<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div v-else class="w-full">
      <vx-card>
        <vs-table
          :max-items="paginationItems[0]"
          pagination
          :data="AccountingRuleList"
          search
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("accounting.label.accountingrules") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Accounting Rule' })"
                size="small"
                >{{ $t("accounting.label.createrule") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("accounting.label.accountingrulename") }}</vs-th>
            <vs-th>{{ $t("accounting.label.entityname") }}</vs-th>
            <vs-th>{{
              $t("accounting.label.allowmultipledebitentries")
            }}</vs-th>
            <vs-th>{{
              $t("accounting.label.allowmultiplecreditentries")
            }}</vs-th>
            <vs-th>{{ $t("accounting.label.debitaccount") }}</vs-th>
            <vs-th>{{ $t("accounting.label.creditaccount") }}</vs-th>
            <vs-th class="tHeadCenter">{{
              $t("accounting.label.action")
            }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="data" v-for="(accounts, index) in data">
              <vs-td :data="accounts.name">{{ accounts.name }}</vs-td>
              <vs-td :data="accounts.officeName">{{
                accounts.officeName
              }}</vs-td>
              <vs-td :data="accounts.allowMultipleDebitEntries">{{
                accounts.allowMultipleDebitEntries
              }}</vs-td>
              <vs-td :data="accounts.allowMultipleCreditEntries">{{
                accounts.allowMultipleCreditEntries
              }}</vs-td>
              <vs-td>{{
                accounts.debitAccounts ? accounts.debitAccounts[0].name : "N/A"
              }}</vs-td>
              <vs-td>{{
                accounts.creditAccounts
                  ? accounts.creditAccounts[0].name
                  : "N/A"
              }}</vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    title="View"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="handleSelected1(accounts.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="EditIcon"
                    title="edit"
                    svgClasses="w-5 h-5 text-warning stroke-current cursor orange_icon"
                    @click.stop="EditAccountMethod(accounts.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    title="delete"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteAccountPopup = true;
                      delId = accounts.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deleteAccountPopup"
      title="Accounting Rule"
      @deletePressed="deleteRule(delId)"
      @cancelPressed="deleteAccountPopup = false"
    >
    </delete-popup>
    <!-- </vx-card> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [10, 20, 30],
      delId: 0,
      deleteAccountPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      AccountingRuleList: (state) => state.accounting.accountingRulesList,
    }),
  },
  methods: {
    async getAccountingRulesMethod() {
      this.loading = true;
      try {
        this.$store.dispatch("accounting/getAccountingRulesListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteRule(id) {
      try {
        this.deleteAccountPopup = false;
        await this.$store.dispatch("accounting/deleteRuleAction", id);
        this.getAccountingRulesMethod();
        this.$toasted.error("Accounting Rule Deleted", {
          duration: 2000,
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    EditAccountMethod(id) {
      this.$router.push({ name: "Edit Accounting Rule", params: { id: id } });
    },

    handleSelected1(id) {
      this.$router.push({
        name: "View Accounting Rule",
        params: { id: id },
      });
    },
  },
  mounted() {
    this.getAccountingRulesMethod();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
